@if (object1 | async; as item) {
  <div class='container containerUK'>
    <!-- <p><strong>References:</strong>
    <br><br> -->
    <div class="ref1" [innerHTML]="item.largeparagraphcontent"></div>
  </div>
}

